<template>
    <section class="base-header-sec base-header-laen  laen">
        <div class="base-header__top-line laen"></div>
        <div class="container-fluid">

            <div class=" container-lg  base-header__container ">
                <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                    <ul class="nav ">
                        <li class="nav-item ">
                            <router-link class="nav-link" to="/news-cat/1/0">Службени гласник РС</router-link>

                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link" to="/news-cat/2/0">Активности државних органа</router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link" to="/news-cat/3/0">Активности у правосуђу</router-link>

                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link" to="/news-cat/4/0">Остало</router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link" to="/news-multimedia/0">Мултимедија </router-link>
                        </li>
                        <li class="nav-item ">
                            <router-link class="nav-link" to="/news-search">Претрага </router-link>
                        </li>
                    </ul>
                    <h1 class="base-header__title">
                        <!--                            <span class="base-header__icon icon-inbox mr-3"></span>-->
                        Новости
                    </h1>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: "NewsBaseHeaderSec"
    }
</script>

<style scoped>

</style>
